export const DATASET_ID = "DatasetID";

export const RECTIFICATION = "Rectification";

export const RESOLUTION = "Resolution";

export const ACQ_DATE_FIRST = "AcqDateFirst";
export const ACQ_DATE_LAST = "AcqDateLast";

export const ACQ_YEAR_FIRST = "AcqYearFirst";
export const ACQ_YEAR_LAST = "AcqYearLast";

export const PRO_DEF = "ProDef";
export const CONSTRAINTS = "Constraints";

export const DEM_TYPE = "DEMType";

export const SCALE = "Scale";

const IMAGERY_FILTERS = [ACQ_YEAR_LAST, RESOLUTION, PRO_DEF, RECTIFICATION];

const IMAGERY_ATTRIBUTES = [
  DATASET_ID,
  CONSTRAINTS,
  ...IMAGERY_FILTERS,
];

const ELEVATION_FILTERS = [DEM_TYPE, RESOLUTION];
const ELEVATION_ATTRIBUTES = [DATASET_ID, ...ELEVATION_FILTERS];

const TOPOGRAPHIC_FILTERS = [SCALE];
const TOPOGRAPHIC_ATTRIBUTES = [DATASET_ID, ...TOPOGRAPHIC_FILTERS];

export const ATTRIBUTES = {
  imagery: IMAGERY_ATTRIBUTES,
  elevation: ELEVATION_ATTRIBUTES,
  topographic: TOPOGRAPHIC_ATTRIBUTES,
};

export const FILTERS = {
  imagery: IMAGERY_FILTERS,
  elevation: ELEVATION_FILTERS,
  topographic: TOPOGRAPHIC_FILTERS,
};
